import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from "@babackapp/ui/components/dropdown-menu";
import { ChevronDownIcon } from "@radix-ui/react-icons";
import { useTranslation } from "react-i18next";
import { FolderIcon } from "lucide-react";
import { TEMPLATE_CATEGORY_IDS, useCategoryLabel } from "../lib/categories";

type CategorySelectionProps = {
  value: string | null;
  onChange: (value: string | null) => void;
};

export function CategorySelection({ value, onChange }: CategorySelectionProps) {
  const { t } = useTranslation("trackoffice");
  const getCategoryLabel = useCategoryLabel();

  const selectedLabel = value
    ? getCategoryLabel(value)
    : t("templatesEditor.categorySelector.allCategories", "Category");

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <span className="inline-flex gap-1 items-center cursor-pointer">
          <FolderIcon className="size-3.5" />
          {selectedLabel} <ChevronDownIcon />
        </span>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {TEMPLATE_CATEGORY_IDS.map((categoryId) => (
          <DropdownMenuCheckboxItem
            key={categoryId}
            checked={value === categoryId}
            onSelect={(e) => {
              e.preventDefault();
              onChange(value === categoryId ? null : categoryId);
            }}
          >
            {getCategoryLabel(categoryId)}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export function CategorySelectionSubmenu({
  value,
  onChange,
}: CategorySelectionProps) {
  const { t } = useTranslation("trackoffice");
  const getCategoryLabel = useCategoryLabel();

  const selectedLabel = value
    ? getCategoryLabel(value)
    : t("templatesEditor.categorySelector.allCategories", "Category");

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger>
        <FolderIcon className="size-3.5" />
        {selectedLabel}
      </DropdownMenuSubTrigger>
      <DropdownMenuPortal>
        <DropdownMenuSubContent>
          {TEMPLATE_CATEGORY_IDS.map((categoryId) => (
            <DropdownMenuCheckboxItem
              key={categoryId}
              checked={value === categoryId}
              onSelect={(e) => {
                // e.preventDefault();
                e.stopPropagation();
                onChange(value === categoryId ? null : categoryId);
              }}
            >
              {getCategoryLabel(categoryId)}
            </DropdownMenuCheckboxItem>
          ))}
        </DropdownMenuSubContent>
      </DropdownMenuPortal>
    </DropdownMenuSub>
  );
}
